import GetSelectedProductIds from "./getSelectedProductIds";
import LoadWishLists from "./loadWishLists";

export default function CopyProductsToWishlist(sender, isFromSubmit, destinationId) {

  var productId = $("#copytowishlist-dialog").data("product-id");
  if (!productId) {
    productId = $(".column-holder").data("productidentifier");
  }

  var parent = sender.parents(".copyToWishlistHolder");
  var uniqueValidator = parent.find(".uniqueValidator");
  var reqValidator = parent.find(".reqValidator");
  var incorrectValidator = parent.find(".incorrectValidator");
  var wishListAddedPanel = parent.find(".wishListAddedPanel");
  var newWishlistToAdd = parent.find(".newWishlistToAdd");

  uniqueValidator.hide();
  reqValidator.hide();
  incorrectValidator.hide();
  wishListAddedPanel.hide();
  newWishlistToAdd.removeClass("error");
  var newName = newWishlistToAdd.val();
  if (isFromSubmit && newName == '') {
    reqValidator.show();
    newWishlistToAdd.addClass("error");
  }
  var productIds = GetSelectedProductIds($("#copytowishlist-dialog").data("wl-id"));

  if (productId) {
    productIds = [productId.toString()];
  }
  var copyProduct = {};
  copyProduct.DestinationWishlistId = destinationId;
  copyProduct.CurrentWishlistId = $("#copytowishlist-dialog").data("wl-id");
  copyProduct.ProductIds = productIds;
  copyProduct.NewWishlistName = newName;

  $.ajax({
    type: "POST",
    url: "/api/CustomersWishlist/CopyProducts",
    data: JSON.stringify(copyProduct),
    contentType: "application/json",
    success: function (data) {
      if (data) {
        if (data.IsNotUniqueName) {
          uniqueValidator.show();
          newWishlistToAdd.addClass("error");
        }
        else if (data.IsIncorrectName) {
          incorrectValidator.show();
          newWishlistToAdd.addClass("error");
        }
        else {
          parent.find(".wishListPanel.wishlistSubmit").hide();
          wishListAddedPanel.show();
          wishListAddedPanel.find(".arrow").html(data.AddedWishlistName);
          if (productId) {
            wishListAddedPanel.find(".arrow").attr("href", "/profile#1")
          }
          else {
            LoadWishLists();
          }
        }
      }
    }
  });
}